import React from "react";
import {DoppeDtoAction} from "../../client-server-common/types/doppe-dto-action";
import {DoppeViewerActionRenderer} from "../doppe-viewer-action-renderer/doppe-viewer-action-renderer";
import {DoppeActionView} from "../../doppe-sdk";
import {DoppeViewerActionContext} from "../doppe-viewer-action-context/doppe-viewer-action-context";
import {
    useBymoPageViewerComponentsContext
} from "../bymo-page-viewer-components-context/bymo-page-viewer-components-context";

export const DoppeViewerActionPopup = React.memo(function DoppeViewerActionPopup(props: DoppeViewerActionPopup.Props) {
    const {
        action,
        actionTogglingController,
        fullScreenModeTogglingController,
        actionIndex,
    } = props;

    const bymoPageViewerComponentsContextData = useBymoPageViewerComponentsContext();


    return (
        <DoppeViewerActionRenderer
            action={action}
            actionIndex={actionIndex}
            actionTogglingController={actionTogglingController}
            fullScreenModeTogglingController={fullScreenModeTogglingController}
        >
            {(actionContext, actionType) => {

                if (actionType.renderWidget === undefined) {
                    return (
                        <div>{`Action type with id '${action.actionTypeId}' doesn't support inline rendering.`}</div>
                    )
                } else {
                    return actionType.renderWidget({
                        actionContext: actionContext
                    }, bymoPageViewerComponentsContextData.actionTypesViewerComponents.get(actionType.id));
                }
            }}
        </DoppeViewerActionRenderer>
    )
});

export namespace DoppeViewerActionPopup {

    export interface ActionViewRenderProps {
        actionViewContextProps: DoppeActionView.ActionContextProps;
    }

    export interface Props {
        action: DoppeDtoAction;
        actionTogglingController?: DoppeViewerActionContext.ActionTogglingController;
        fullScreenModeTogglingController?: DoppeViewerActionContext.FullScreenModeTogglingController;
        actionIndex?: number;
    }

}